import { render, staticRenderFns } from "./user-partner.vue?vue&type=template&id=0c21d378&scoped=true"
import script from "./user-partner.vue?vue&type=script&lang=js"
export * from "./user-partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c21d378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c21d378')) {
      api.createRecord('0c21d378', component.options)
    } else {
      api.reload('0c21d378', component.options)
    }
    module.hot.accept("./user-partner.vue?vue&type=template&id=0c21d378&scoped=true", function () {
      api.rerender('0c21d378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/user-partner.vue"
export default component.exports